import type { ComponentProps, ComponentType, PropsWithChildren } from "react";
import {
  ErrorBoundary as InternalErrorBoundary,
  SHELL_ID,
  getComponentName,
} from "@aviv-unified-frontend/internal";

import { GeneralErrorPage } from "../../pages/errors";
import { logger } from "../../utils/logger";

type ErrorBoundaryProps = PropsWithChildren<{
  name: string;
}>;

export const ErrorBoundary = ({ name, children }: ErrorBoundaryProps) => (
  <InternalErrorBoundary
    id={`${SHELL_ID}_${name}`}
    onError={logger.error}
    fallback={GeneralErrorPage}
  >
    {children}
  </InternalErrorBoundary>
);

export const withErrorBoundary =
  (errorBoundaryProps: Omit<ErrorBoundaryProps, "children">) =>
  (Component: ComponentType) => {
    const WrappedComponent = (props: ComponentProps<typeof Component>) => (
      <ErrorBoundary {...errorBoundaryProps}>
        <Component {...props} />
      </ErrorBoundary>
    );

    WrappedComponent.displayName = `WithErrorBoundary(${getComponentName(Component)})`;

    return WrappedComponent;
  };
